var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Form as FForm, Formik, useFormikContext } from "formik";
import React, { useEffect, useRef } from "react";
import * as yup from "yup";
import { FormikErrorFocus } from ".";
import { Button } from "../Button";
import { Div } from "../utils";
import { ErrorMessageWarning } from "./ErrorMessageWarning";
export const getFormikProps = (fields) => {
    const initialValues = fields.reduce((initialValues, f) => (Object.assign(Object.assign({}, initialValues), { [f.name]: f.initialValue })), {});
    const validationSchema = yup.object().shape(fields.reduce((validations, f) => (Object.assign(Object.assign({}, validations), { [f.name]: f.validation })), {}));
    return { initialValues, validationSchema };
};
export const FormikSumbitButton = (_a) => {
    var { variant = undefined, isDisabled = false, children, disableOnErrors = false } = _a, props = __rest(_a, ["variant", "isDisabled", "children", "disableOnErrors"]);
    const { submitForm, errors } = useFormikContext();
    const hasErrors = Object.keys(errors).length > 0;
    return (React.createElement(Button, Object.assign({}, Object.assign({ variant }, props), { isDisabled: (hasErrors && disableOnErrors) || isDisabled, onClick: submitForm }), children));
};
export const Form = (_a) => {
    var { fields, onSubmit, children } = _a, props = __rest(_a, ["fields", "onSubmit", "children"]);
    return (React.createElement(Div, Object.assign({}, props),
        React.createElement(Formik, Object.assign({}, getFormikProps(fields), { validateOnChange: false, onSubmit: onSubmit, enableReinitialize: true }), () => React.createElement(FormWithContext, null, children))));
};
const FormWithContext = ({ children }) => {
    const { values, validateForm } = useFormikContext();
    const timeoutRef = useRef(null);
    useEffect(() => {
        if (timeoutRef.current)
            clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
            validateForm(values);
        }, 500);
    }, [values]);
    return (React.createElement(FForm, null,
        React.createElement(ErrorMessageWarning, { mt: 30, mb: 20 }),
        children,
        React.createElement(FormikErrorFocus, null)));
};
//# sourceMappingURL=Form.js.map